import { colors } from '../variables';

export const getUserImportanceColor = (userImportance) => {
  switch (userImportance) {
    case 'high': {
      return colors.colorSchoolBusYellow;
    }
    case 'middle': {
      return colors.colorGallery;
    }
    default: {
      return 'transparent';
    }
  }
};
